module.exports = __webpack_public_path__ + "static/media/X1_REFL.dc2f42ab.png";